import * as THREE from 'three';
import { DragControls } from 'three/examples/jsm/controls/DragControls.js';

// Szene, Kamera und Renderer erstellen
const scene = new THREE.Scene();
const camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
const renderer = new THREE.WebGLRenderer();

renderer.setSize(window.innerWidth, window.innerHeight);
document.querySelector('main').appendChild(renderer.domElement);

// Licht hinzufügen
const light = new THREE.DirectionalLight(0xffffff, 1);
light.position.set(10, 10, 10).normalize();
scene.add(light);

// Array für Blöcke
const blocks = [];
const blockColors = [0xff0000, 0x00ff00, 0x0000ff, 0xffff00, 0xff00ff, 0x00ffff];

// Spielkonstanten
const GRAVITY = 0.05; // Wie schnell die Blöcke fallen
const GROUND_Y = -4;  // Y-Position des "Bodens"
const BLOCK_SIZE = 1; // Größe der Blöcke (Standard BoxGeometry ist 1x1x1)
const Z_MOVE_SPEED = 0.2; // Geschwindigkeit für das Verschieben in der Tiefe

let currentlyDraggedBlock = null;

// Funktion zum Erstellen eines Blocks
const createBlock = (x, y, z, hasCross = false) => {
    const geometry = new THREE.BoxGeometry(BLOCK_SIZE, BLOCK_SIZE, BLOCK_SIZE);
    const material = new THREE.MeshStandardMaterial({ color: blockColors[Math.floor(Math.random() * blockColors.length)] });
    const block = new THREE.Mesh(geometry, material);
    block.position.set(x, y, z);
    block.userData.hasCross = hasCross; // Speichere, ob der Block ein Kreuz hat
    block.isFalling = true; // Neue Blöcke sollen anfangs fallen
    scene.add(block);
    blocks.push(block);
};

// Zufällige Blöcke generieren
for (let i = 0; i < 10; i++) {
    // 30% Wahrscheinlichkeit, dass ein Block ein Kreuz hat
    const hasCross = Math.random() < 0.3;
    // Blöcke etwas höher starten lassen, damit sie fallen können
    createBlock(Math.random() * 10 - 5, Math.random() * 5 + 2, Math.random() * 10 - 5, hasCross);
}

// DragControls für das Verschieben von Blöcken
const controls = new DragControls(blocks, camera, renderer.domElement);

// Event Listener für DragControls
controls.addEventListener('dragstart', function (event) {
    currentlyDraggedBlock = event.object;
    currentlyDraggedBlock.material.opacity = 0.5; // Mach den Block leicht durchsichtig beim Ziehen
    currentlyDraggedBlock.isFalling = false; // Während des Ziehens fällt der Block nicht
});

controls.addEventListener('dragend', function (event) {
    if (currentlyDraggedBlock) {
        currentlyDraggedBlock.material.opacity = 1.0; // Setze die Opazität zurück
        currentlyDraggedBlock.isFalling = true; // Nach dem Loslassen soll der Block fallen
    }
    currentlyDraggedBlock = null;

    // Hier könnte später die Stapel-Logik hinzukommen
    // z.B. Position auf einem Raster einrasten lassen:
    // event.object.position.x = Math.round(event.object.position.x);
    // event.object.position.y = Math.round(event.object.position.y);
    // event.object.position.z = Math.round(event.object.position.z);
});


// Kamera positionieren
camera.position.z = 15; // Etwas weiter weg, um mehr Platz zum Ziehen zu haben

// Animationsschleife
function animate() {
    requestAnimationFrame(animate);

    // Blöcke nicht mehr automatisch rotieren lassen, damit man sie besser greifen kann
    // blocks.forEach((block) => {
    //     block.rotation.x += 0.01;
    //     block.rotation.y += 0.01;
    // });

    // Physik-Update für fallende Blöcke
    blocks.forEach(block => {
        if (block.isFalling) {
            block.position.y -= GRAVITY;

            let landedOnBlock = false;
            // Kollision mit anderen Blöcken prüfen
            for (const otherBlock of blocks) {
                if (block === otherBlock) continue; // Nicht mit sich selbst prüfen

                // Prüfen, ob der fallende Block über dem anderen Block ist
                // und ob er in der nächsten Bewegung auf ihm landen würde.
                // Und ob sie sich in X und Z Richtung überlappen.
                const willLandOnOther =
                    block.position.y > otherBlock.position.y && // Fallender Block ist drüber
                    (block.position.y - GRAVITY - (BLOCK_SIZE / 2)) <= (otherBlock.position.y + (BLOCK_SIZE / 2)) && // Wird landen
                    Math.abs(block.position.x - otherBlock.position.x) < BLOCK_SIZE && // X-Überlappung
                    Math.abs(block.position.z - otherBlock.position.z) < BLOCK_SIZE;   // Z-Überlappung

                if (willLandOnOther) {
                    block.position.y = otherBlock.position.y + BLOCK_SIZE; // Exakt positionieren
                    block.isFalling = false;
                    landedOnBlock = true;
                    checkAndExplodeStacks(block); // Nach Landung auf Block prüfen
                    break;
                }
            }

            // Wenn nicht auf einem anderen Block gelandet, Bodenkollision prüfen
            if (!landedOnBlock && block.isFalling) {
                if (block.position.y - (BLOCK_SIZE / 2) <= GROUND_Y) {
                    block.position.y = GROUND_Y + (BLOCK_SIZE / 2); // Exakt positionieren
                    block.isFalling = false;
                    // Für einen einzelnen Block auf dem Boden brauchen wir keine Explosion prüfen,
                    // es sei denn, er vervollständigt einen Turm, der bereits auf dem Boden steht.
                    // Die aktuelle Logik prüft von oben nach unten, wenn ein Block landet.
                }
            }
        }
    });

    renderer.render(scene, camera);
}

// Funktion zum Überprüfen und Explodieren von Stapeln
function checkAndExplodeStacks(topBlock) {
    const stack = [topBlock];
    let currentBlock = topBlock;

    // Nach unten suchen nach Blöcken im Stapel
    while (stack.length < 3) {
        let foundBlockBelow = null;
        for (const otherBlock of blocks) {
            if (otherBlock === currentBlock) continue;

            // Prüfen, ob otherBlock direkt unter currentBlock ist
            const isDirectlyBelow =
                Math.abs(currentBlock.position.x - otherBlock.position.x) < BLOCK_SIZE / 2 && // X-nah genug
                Math.abs(currentBlock.position.z - otherBlock.position.z) < BLOCK_SIZE / 2 && // Z-nah genug
                Math.abs(currentBlock.position.y - BLOCK_SIZE - otherBlock.position.y) < 0.1; // Y-Position passt

            if (isDirectlyBelow && !otherBlock.isFalling) { // Nur auf bereits gelandeten Blöcken stapeln
                foundBlockBelow = otherBlock;
                break;
            }
        }

        if (foundBlockBelow) {
            stack.push(foundBlockBelow);
            currentBlock = foundBlockBelow;
        } else {
            break; // Kein Block mehr darunter gefunden
        }
    }

    // Wenn ein Stapel von 3 oder mehr gefunden wurde
    if (stack.length >= 3) {
        console.log("Explosion!", stack.map(b => b.id));
        stack.forEach(blockToRemove => {
            scene.remove(blockToRemove);
            const index = blocks.indexOf(blockToRemove);
            if (index > -1) {
                blocks.splice(index, 1);
            }
            // Wichtig: DragControls müssen möglicherweise aktualisiert werden, wenn Objekte entfernt werden.
            // Für den Moment hoffen wir, dass es keine Probleme gibt.
            // Alternativ: controls.dispose(); controls = new DragControls(blocks, camera, renderer.domElement);
        });
        // Optional: Hier könnten Punkte vergeben oder neue Blöcke erzeugt werden.
    }
}

// Funktion zur Verarbeitung von Tastatureingaben für Z-Verschiebung
function handleKeyDown(event) {
    if (!currentlyDraggedBlock) {
        return; // Nur agieren, wenn ein Block gezogen wird
    }

    switch (event.key.toLowerCase()) {
        case 'w': // Block nach hinten (weiter weg)
            currentlyDraggedBlock.position.z -= Z_MOVE_SPEED;
            break;
        case 's': // Block nach vorne (näher ran)
            currentlyDraggedBlock.position.z += Z_MOVE_SPEED;
            break;
    }
}

// Event Listener für Tastendrücke hinzufügen
window.addEventListener('keydown', handleKeyDown);

animate();